import React, { useRef } from "react";
import { SectionHeader } from "./ui/SectionHeader";
import { testimonials } from "../data/content";
import { Star, ChevronLeft, ChevronRight, MoveHorizontal } from "lucide-react";
export function SocialProof() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      // Un desplazamiento de 400px es suficiente para que el CSS snap-mandatory 
      // lo ajuste automáticamente a la siguiente tarjeta centrada.
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full bg-white py-10 md:py-16" data-id="element-249" data-mp="3ut0u4sl6r1p8">
      <div className="container mx-auto px-4 md:px-6 max-w-[1120px]" data-id="element-250" data-mp="3urg157eirqth">
        
        <div className="mb-10 md:mb-14 max-w-5xl mx-auto" data-id="element-251" data-mp="mc63qclkr9s1">
          <div className="rounded-[16px] md:rounded-[20px] overflow-hidden shadow-xl border-4 border-gray-100 max-w-3xl mx-auto" data-id="element-252" data-mp="r4z8v1kygk4n">
            <img src="https://cdn.magicpatterns.com/uploads/9nDNQ4FdnvwZEta1qWDEdX/ChatGPT_Image_8_ago_2026,_23_17_17.webp" alt="Alumnos con certificado" className="w-full h-auto" data-id="element-253" data-mp="1uammbutxxlxw" />
          </div>
        </div>

        <SectionHeader theme="light" title={<>LO QUE DICEN NUESTROS <span className="text-[#F3AD00]" data-id="element-255" data-mp="1z8efes6bne3o">ALUMNOS</span></>} className="mb-8 md:mb-10" data-id="element-254" data-mp="2417k5g1simfr" />

        <div className="relative max-w-5xl mx-auto" data-id="element-256" data-mp="2d02qcs4u3wj2">
          {/* Flechas de navegación para Desktop */}
          <button onClick={() => scroll('left')} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-12 z-10 bg-white rounded-full p-3 shadow-[0_4px_20px_rgba(0,0,0,0.1)] border border-gray-100 text-[#142FA8] hover:bg-[#F5F7F9] hover:scale-110 transition-all" aria-label="Anterior" data-id="element-257" data-mp="281re6ar2h9xo">
            <ChevronLeft className="w-6 h-6" data-id="element-258" data-mp="slah6nx4a1zj" />
          </button>
          
          <button onClick={() => scroll('right')} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-12 z-10 bg-white rounded-full p-3 shadow-[0_4px_20px_rgba(0,0,0,0.1)] border border-gray-100 text-[#142FA8] hover:bg-[#F5F7F9] hover:scale-110 transition-all" aria-label="Siguiente" data-id="element-259" data-mp="nm69k1puccbb">
            <ChevronRight className="w-6 h-6" data-id="element-260" data-mp="1m8ncythgocdu" />
          </button>

          <div ref={scrollRef} className="flex overflow-x-auto pb-6 md:pb-8 -mx-4 px-4 md:mx-0 md:px-0 gap-5 md:gap-8 snap-x snap-mandatory hide-scrollbar" data-id="element-261" data-mp="1r9l25q0w26ou">
            {testimonials.map((testimonial, idx) => <div key={idx} className="snap-center shrink-0 w-[85vw] sm:w-[350px] md:w-[450px] bg-[#F5F7F9] p-6 md:p-8 rounded-[16px] shadow-sm border border-gray-200 flex flex-col h-full" data-id="element-262" data-mp="2097vdojgs66t" data-mpi={idx}>
                <div className="flex items-center gap-4 mb-5" data-id="element-263" data-mp="2a0c80hlo3eyh">
                  <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 md:w-16 md:h-16 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-264" data-mp="2a1nckjmxsqqn" />
                  <div data-id="element-265" data-mp="2jyi9iy3kaj2t">
                    <h4 className="font-[800] text-[#07152D] text-[16px] md:text-[18px]" data-id="element-266" data-mp="2jvw537bywjot">{testimonial.name}</h4>
                    <p className="text-[13px] md:text-[14px] text-gray-500 font-[600]" data-id="element-267" data-mp="88aiecqlq6ej">{testimonial.occupation}</p>
                  </div>
                </div>
                
                <div className="flex gap-1 mb-4" data-id="element-268" data-mp="3ui3jrnf51z0e">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 md:w-5 md:h-5 fill-[#FFC900] text-[#FFC900]" data-id="element-269" data-mp="3pk1ziz5z7tnc" />)}
                </div>
                
                <p className="text-[#07152D] leading-[1.5] italic flex-grow text-[14px] md:text-[16px] font-[500]" data-id="element-270" data-mp="r2za3xpcekbr">
                  "{testimonial.comment}"
                </p>
              </div>)}
          </div>

          {/* Indicador visual para Mobile */}
          <div className="flex md:hidden items-center justify-center gap-2 mt-2 text-gray-400 text-[13px] font-[600]" data-id="element-271" data-mp="cbp85v4ce156">
            <MoveHorizontal className="w-4 h-4" data-id="element-272" data-mp="19tp9vdjm9r0e" />
            <span data-id="element-273" data-mp="150nr2ugah7bj">Deslizá para ver más</span>
          </div>
        </div>
      </div>
    </section>;
}